<template>
  <div class="row pt-3 dashboard pb-4">
    <div class="col-md-4">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          ORDERS TO PICK
          <span class="badge badge-dark p-2">{{ dashboard.to_pick.length }}</span>
        </div>
        <div class="list-group list-group-flush">
          <router-link
            v-for="order in dashboard.to_pick"
            :key="order.id" 
            :to="`/outbound/${order.status.slug}/${order.id}`"
            class="list-group-item list-group-item-action d-flex flex-row px-2 py-2 pr-4"
          >
            <img class="mr-2" src="https://lm-web-assets.s3.us-east-2.amazonaws.com/logos/feather.png"
              style="height: 75px; border-radius: 10px;"
            >
            <div class="w-100">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1">{{ order.number }} </h6>
                <small> {{moment(order.created_at).calendar() }}</small>
              </div>
              <p class="mb-1">{{ order.client.nickname}}</p>
              <small>{{ order.items.length }} Line Items</small>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      
    </div>

    <div class="col-md-4">
      
    </div>

  </div>
</template>

<script>

import api from '@/api'
import moment from 'moment'

export default {
  name: 'dashboard',

  data() {
    return {
      dashboard: { to_pick: [] }
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      api.get('/dashboard').then(res => {
        this.dashboard = res.data.dashboard
      })
    },

    moment(data) {
      return moment(data)
    }
  }
}
</script>

<style scoped>
.dashboard {
  overflow-y: auto;
  height: calc(100vh - 48px);
}

.dashboard h1 {
  justify-self: center;
  color: #cfcfcf;
}
</style>